import React, { Component } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

class Post extends Component {

    constructor() {
        super();
        // super(props);
        this.state = {
            loading: true,
            error: "",
            post: null
        };
    }

    async componentDidMount() {
        let postId = this.props.match.params.id;
        this.setState({ loading: true });
        try{
            const response = await axios.get(`/api/blog/${postId}`)
            this.setState({ post: response.data.data });
        } catch (e) {
            this.setState({ error: e });
        } finally {
            this.setState({ loading: false });
        }
    }

    render() {
        const { loading, error, post } = this.state;
        if (error) {
            return <PostCard error={true} imageHTML={false} contentHTML={error} />
        }
        if (loading) {
            return <PostCard loading={true} imageHTML={false} contentHTML="Loading..." />
        }

        return (
            <PostCard
                title={post.title}
                imageHTML={<ImageGallery images={post.images} title={post.title}/>}
                contentHTML={post.body}
            />
        );
    }
}

let ImageGallery = ({images, title}) => {
    if(images && images.length > 1){
        let carouselItems = images.map((img, i) => {
            return (
                <div key={i}>
                    <img  alt={title} src={`${s3AwsEndpoint}/${img.name}`} />
                </div>
            )
        });

        return (
            <Carousel>
                {carouselItems}
            </Carousel>
        );
    }
    else if(images && images.length === 1) {
        return (
            <img
                className="img-fluid cover-image"
                src={`${s3AwsEndpoint}/${images[0].name}`}
                alt={title}
            />
        );
    }

    return (
        <img
            className="img-fluid"
            src={`${s3AwsEndpoint}/blog/placeholder-image.jpg`}
            alt={title}
        />
    );
}

class PostCard extends Component {
    constructor(props) {
        super(props);
    }

    render(){
        const { contentHTML, imageHTML } = this.props;
        return (
            <section id="blog-detail" className="main-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 cover-image-container">
                            <div className="col-12 col-md-6 offset-md-3 cover-image-title">
                               <h3 className="title py-5">{this.props.title}</h3>
                               {imageHTML}
                            </div>
                            <div className="col-12 col-md-6 offset-md-3 text-left article-body">
                                <div className="single-package-wrapper">
                                    <div className="singel-packages">
                                        <div className="packages-title">
                                            <div className="title-wrapper" dangerouslySetInnerHTML={{
                                                __html: contentHTML
                                            }}>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Post;
